export const HEAD_PHONE = '+998';
